import { Fragment, ReactNode } from "react";

const newlineRegex = /[\r\n]+/g;

const Nl2br = ({ children }: { children: ReactNode }): JSX.Element | null => {
  if (typeof children === "string") {
    const lines = children.split(newlineRegex);
    return (
      <>
        {lines.map((line: string, index: number) => (
          <Fragment key={index}>
            {line}
            {index < lines.length - 1 && <br />}
          </Fragment>
        ))}
      </>
    );
  }
  return null;
};

export default Nl2br;
